module.exports = __webpack_public_path__ + "media/photo/AdobeStock_249145115-29e5bcc4.jpg";